import { YEAR_WHEN_GP_APPEARS } from 'legacy/lut/features/globalPartner/constants'
import {
  changeFinancialYear,
  selectFinancialYear,
} from 'legacy/lut/features/partner360/configuration'
import { getUrlFYear } from 'legacy/lut/features/partner360/configuration/helpers/getUrlFYear'
import { useAvailableFYears, useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { IFYearOption } from '../models/fYearOption'

export const useFYearsCrud = (partnerId: string) => {
  const currentFYear = useSelector(selectFinancialYear)
  const dispatch = useAppDispatch()
  const { jbpSettings, isLoaded } = useJbpSettings()
  const availableFYears = useAvailableFYears()

  const fYears = useMemo(() => {
    const isGlobalPartner = partnerId.startsWith('GP')

    return availableFYears.filter((fYear) => {
      if (isGlobalPartner) {
        return fYear >= YEAR_WHEN_GP_APPEARS
      }

      return true
    })
  }, [availableFYears, partnerId])

  const fYearsCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(fYears.map<IFYearOption>((year) => ({ partnerId, fYear: year }))),
      keyField: 'fYear',
      defaultPaging: { page: 0, pageSize: fYears.length },
      defaultSort: { field: 'fYear', dir: 'asc' },
    })
  }, [fYears, partnerId])

  const onChangeFYear = useCallback(
    (fYear: string) => {
      const parsedFYear = parseInt(fYear, 10)
      if (!isNaN(parsedFYear)) {
        dispatch(changeFinancialYear(parsedFYear))
        return
      }

      if (!fYears.includes(parsedFYear)) {
        dispatch(changeFinancialYear(fYears[0]))
      }
    },
    [dispatch, fYears]
  )

  useEffect(() => {
    if (!isLoaded) {
      return
    }

    const fYear = partnerId.startsWith('GP')
      ? getUrlFYear() || jbpSettings.currentFYear
      : currentFYear || jbpSettings.fYears[jbpSettings.fYears.length - 1]

    if (fYear) {
      onChangeFYear(fYear.toString())
    }
  }, [
    isLoaded,
    onChangeFYear,
    jbpSettings.fYears,
    jbpSettings.currentFYear,
    currentFYear,
    partnerId,
  ])

  return {
    currentFYear,
    setCurrentFYear: onChangeFYear,
    fYearsCrud,
    isLoaded,
  }
}
